import React, { useState } from 'react';

export default function Consagraciones() {
  const [fontSizes, setFontSizes] = useState(16)

  const aumentar = () => {
    if (fontSizes < 22) {
      const newSize = fontSizes + 2;
      setFontSizes(newSize)
    }
  }
  const restar = () => {
    if (fontSizes > 12) {
      const newSize = fontSizes - 2;
      setFontSizes(newSize)
    }
  }

  return (
    <>
      <div className="container pt-5 pb-5">
        <div id="mensajes-body" className={'font-' + fontSizes}>
          <div className="row text-center mt-3">
            <div className="col-12">
              <h5>Consagración al Sacratísimo Corazón Eucarístico de Jesús</h5>
              <p className="mt-4">
                Sacratísimo Corazón Eucarístico de Jesús, Yo confío inmensamente en Tu Misericordia. <br />
                Te pido humildemente que me des la fe que necesito para abandonarme a Tu Infinita Misericordia, porque ya se han agotado mis recursos humanos y ahora solo me cabe volverme con confianza a Tu Infinita Compasión, porque sé que Tú no desoirás mi súplica. <br />
                Aquí estoy Señor a Tus pies pidiendo con fervor arregles todas mis cosas y problemas, según Tu Amor y Beneplácito divino, que sé, será lo mejor para mí, concédeme lo que te estoy pidiendo, si es para bien de mi alma. <br />
                ¡Toma Señor mi problema! ¡Toma mi corazón! <br />
                ¡Yo confío en Ti, Corazón Eucarístico de Jesús! <br />
                ¡Yo confío en Ti, Corazón Eucarístico de Jesús! <br />
                ¡Yo confío en Ti, Corazón Eucarístico de Jesús! <br />
                Amén.
              </p>
            </div>
            <div className="lineafinal mt-4 mb-5">
            </div>
            <div className="col-12 pb-4">
              <h5>Acto de Consagración al Inmaculado Corazón de María</h5>
              <p className="mt-4">
                Purísima Madre mía, quiero consagrarte mi corazón, mi voluntad, mi vida entera. <br />
                Llévame al Corazón de tu Divino Hijo Jesús, para que El habite en mí. <br />
                Quiero ser totalmente tuyo Madre mía y a partir de hoy, servirte fielmente en lo que me mandes. <br />
                Sé dulce compañía en mi vida, no permitas que jamás me separe de Ti y en la hora de la muerte ven a buscarme para gozar de la eternidad en Tu compañía. <br />
                Bendita y Alabada seas por siempre Madre Mía. <br />
                Amén.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="btn-fonts d-flex">
        <button onClick={aumentar}>
          <strong>A</strong>
        </button>
        <button onClick={restar} style={{ fontSize: '1.1rem' }} >
          <strong>A</strong>
        </button>
      </div>
    </>
  );
}
